module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('title')) + "\n  ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.me) ? _c('v-card-text', [_c('blockquote', {
    staticClass: "blockquote pl-0 pt-0"
  }, [_vm._v(_vm._s(_vm.$t('subtitle')) + "\n    ")]), _vm._v(" "), _c('h4', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('link.overline')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "file_copy",
      "value": _vm.referralLink,
      "hint": _vm.copyLinkText,
      "persistent-hint": true,
      "box": ""
    },
    on: {
      "click:append": _vm.copyToClipboard
    }
  }), _vm._v(" "), (_vm.loadingFunnel) ? _c('v-progress-linear', {
    attrs: {
      "height": 2,
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.funnel) ? [_c('h4', {
    staticClass: "overline mt-4"
  }, [_vm._v(_vm._s(_vm.$t('stats.title')))]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.referred')) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.funnel.total) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.ontrial')) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.funnel.referred) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.converted')) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.funnel.converted) + "\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card', {
    staticClass: "metric"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('subtitles.creditbalance')) + "\n              "), _c('v-spacer'), _vm._v(" "), _c('help-popover', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('credits.helptext')) + "\n              ")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("\n              " + _vm._s(_vm.formatnumber(_vm.credits.available, true)) + "\n            ")])], 1)], 1)], 1)] : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34aebdec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/Earn.vue
// module id = 1387
// module chunks = 9